import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import FormulaValue from "../../../components/formula-value";
import FormulaName from "../../../components/formula-name";
import { getRequest } from '../../../../../api/ApiService';
import { fetchTeamMetrics } from '../../../../../api/MetricsService';
import { fetchFinancialStatements } from '../../../../../api/FinancialStatementsService';
import Teams from '../../../../../api/Teams';
import Auth from '../../../../../routes/Auth';
import { Loader } from 'react-loaders';

class GrossMarginsStep2 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      sellingPrice: 0,
      unitCost: 0,
      grossMargin: 0,
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    const gameId = Number(Auth.getGameId());
    const team = Teams.currentTeam();
    const teamId = Number(team.id);

    Promise.all([
      fetchTeamMetrics(teamId, roundId),
      fetchFinancialStatements({ roundNumber: activeRound }),
      getRequest(`${process.env.REACT_APP_API_URL}v2/games/targets/?course=${Auth.getCourseId()}`),
    ])
      .then(([metricsResults, financialData, targetsRes]) => {
        const currentRoundMetrics = metricsResults.find(i => (
          Number(i.game) === gameId && Number(i.round) === roundId
        ));

        const netRevenues = currentRoundMetrics ? Number(currentRoundMetrics.net_revenues || 0) : 0;
        const unitsSold = currentRoundMetrics ? Number(currentRoundMetrics.units_sold || 0) : 0;
        const sellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;

        const incomeStatement = financialData.incomeStatement;
        const currentRoundIncomeStatement = incomeStatement.find(i => i.Round === activeRound);
        const costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
        const unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;

        const targets = targetsRes.body;
        const currentRoundTargets = targets.find(i => i.round_number === activeRound);

        this.setState({
          loaded: true,
          sellingPrice,
          unitCost,
          grossMargin: Number(currentRoundTargets.gross_margin || 0),
        })
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      sellingPrice,
      unitCost,
      grossMargin,
    } = this.state;
    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="GROSS MARGINS"
        previousShownErrors={previousShownErrors}
        alertText="Your product(s) generated insufficient margins"
        paragraph2={(
          <Fragment>
            The gross profit spread between your product’s <b>${sellingPrice.toFixed(2)}</b> average selling price and
            the <b>${unitCost.toFixed(2)}</b> average cost to manufacture each unit was <b>${(sellingPrice - unitCost).toFixed(2)}</b>, which was not enough
            to generate the gross profit margin needed to hit the <b>{Number((grossMargin * 100).toFixed(2))}%</b> gross margin target.
          </Fragment>
        )}
        visual={(
          <Fragment>
            <FormulaName background="#fec665" color="rgba(0, 27, 59, 0.94)">
              Gross Profit Margin<br />
              Per Unit of Sale
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Selling Price - Unit Cost
              <span className='divider' />
              Selling Price
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              ${(sellingPrice - unitCost).toFixed(2)}
              <span className='divider' />
              ${sellingPrice.toFixed(2)}
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#d5d9dd',
          background: '#fbedd5',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default GrossMarginsStep2;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/gross-margins/step2.js